export default {
    get({ idDistrict, idWard }) {
        return window.axios.get('/location/v4/get', { params: { idDistrict, idWard }})
    },
}